type TRating = {
  interactiveDescription?: string;
  ratingDescription?: string;
  ratingName?: string;
  ratingUrl?: string;
  ratingIconUrl?: string;
};

const gameDetailsRatingContainerId = 'game-details-rating-container';
const gameDetailsRatingContainer = (): HTMLElement | null =>
  document.getElementById(gameDetailsRatingContainerId);
const ratingData = (): TRating | undefined => gameDetailsRatingContainer()?.dataset;

export default {
  gameDetailsRatingContainerId,
  gameDetailsRatingContainer,
  ratingData
};
